'use client'

import type { ChainId } from '@morpho-org/blue-sdk'

import { InterfaceChainUtils } from '@morpho-org/dapp-core'
import { ChainIcon } from '@repo/web3'
import { forwardRef, type Ref } from 'react'

import { Avatar, type BaseAvatarProps } from './Avatar'

interface NetworkProps {
  chainId?: ChainId
  srcAvatarProps?: Omit<BaseAvatarProps, 'imageProps'>
}

export const NetworkAvatar = forwardRef<HTMLDivElement, NetworkProps>(
  ({ chainId, srcAvatarProps }: NetworkProps, ref: Ref<HTMLDivElement>) => {
    if (!chainId || !InterfaceChainUtils.isDeployedOnChain.id(chainId)) {
      return <Avatar src="" ref={ref} rounded {...srcAvatarProps} />
    }

    return (
      <Avatar
        icon={<ChainIcon chainId={chainId} className="h-full w-full" />}
        ref={ref}
        rounded
        {...srcAvatarProps}
      />
    )
  }
)

NetworkAvatar.displayName = 'NetworkAvatar'
